import { useCallback } from 'react';
import { ISignal, useCustomFetch } from "../custom-fetch";
import { IWheelsStation } from '../shared/IReservation';
import IPriceQuote from '../shared/IPriceQuote';
import IExtra from '../shared/IExtra';

export interface IPriceQuoteRequest {
  departureDate: string;
  departureTime: string;
  departureStation: string;
  returnDate: string;
  returnTime: string;
  returnStation: string;
  discountCode: string;
}

export const useBookingService = () => {
  const customFetch = useCustomFetch();

  const fetchStations = useCallback(async ({ signal }: ISignal) => {
    const [data] = await customFetch<IWheelsStation[]>("/json/stations", { signal });
    return data;
  }, [customFetch]);

  const fetchPrices = useCallback(async (request: IPriceQuoteRequest) => {
    const [data] = await customFetch<IPriceQuote>("/json/pricequotes/agent", {
      method: "POST",
      body: JSON.stringify(request),
    });
    return data;
  }, [customFetch]);

  const fetchExtras = useCallback(async ({ signal }: ISignal) => {
    const [data] = await customFetch<any>("/json/pricequotes/extras", { signal });

    const sourceData: Record<string, IExtra> = data.options;
    const extras: IExtra[] = Object.values(sourceData);

    return extras;
  }, [customFetch]);

  return {
    fetchStations,
    fetchPrices,
    fetchExtras
  };
};